<ion-app>
  <app-navbar />
  <!-- <ion-split-pane contentId="main-content" [when]="false"> -->
  <!-- <app-menu /> -->

  <ion-router-outlet class="top" id="main-content" />
  <!-- </ion-split-pane> -->
</ion-app>
